export default function HorizontalLineDivider() {
  return <hr className="m-0 border-t border-gray-100 dark:border-gray-700" />;
}
